import styles from "./dashboardPage.module.css";
import CountCards from "../../components/countCards/CountCards";
import TrendingQuizs from "../../components/trendingQuizs/TrendingQuizs";
import Sidebar from "../../components/sidebar/Sidebar";
import { useEffect, useState } from "react";
import { GetAllQuizData } from "../../apis/quiz";
import { useNavigate } from "react-router-dom";

export default function DashboardPage({
  setIsLoggedIn,
  quizData,
  setQuizData,
}) {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const [isLoading, setIsloading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (!userId || userId === "null" || userId === "undefined") {
        setIsLoggedIn(false);
        setQuizData([]);
        navigate("/");
        return;
      }

      setIsloading(true);
      setErrorMessage("");
      try {
        const allQuizData = await GetAllQuizData(userId);
        setQuizData(allQuizData?.quizData || []);
      } catch (error) {
        console.error(error);
        setQuizData([]);
        setErrorMessage(
          "Dashboard data could not be loaded. Make sure the backend server is running."
        );
      } finally {
        setIsloading(false);
      }
    };
    fetchData();
  }, [navigate, setIsLoggedIn, setQuizData, userId]);

  return (
    <>
      <div className={styles.appLayout}>
        <Sidebar setIsLoggedIn={setIsLoggedIn} />
        {isLoading ? (
          <div className={styles.spinnerContainer}>
            <div className={styles.loadingSpinner}></div>
          </div>
        ) : (
          <div className={styles.dashboard_container}>
            <div className={styles.main_page_container}>
              <div className={styles.main_page_subcontainer}>
                {errorMessage && (
                  <p className={styles.errorMessage} role="alert">
                    {errorMessage}
                  </p>
                )}
                <div className={styles.pageHeader}><div><p className={styles.eyebrow}>OVERVIEW</p><h1>Welcome back</h1><p>Track performance and keep your quizzes growing.</p></div></div>
                <CountCards quizData={quizData} />
                <TrendingQuizs quizData={quizData} />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
